module.exports = __webpack_public_path__ + "static/media/ic-fbg-logo.74475e63.svg";